import { render, staticRenderFns } from "./Filedropper.vue?vue&type=template&id=3ba145c0&scoped=true&"
import script from "./Filedropper.vue?vue&type=script&lang=js&"
export * from "./Filedropper.vue?vue&type=script&lang=js&"
import style0 from "./Filedropper.vue?vue&type=style&index=0&id=3ba145c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba145c0",
  null
  
)

export default component.exports